import FullProfileModalBase from "./FullProfileModalBase";
import React, {Fragment} from "react";
import ArrowIndicator from "./components/ArrowIndicator";
import GoalMap from "../../../../ui/canvases/GoalMap";
import '../../../../../assets/sass/pages/full-profile/tabs/modals/duels-modal.scss';
import DuelsDataTable from "./duels_modal/DuelsDataTable";
import calvinFloresAvatar from '../../../../../assets/img/demo/calvin-flores-avatar.png';
import bernardNguyenAvatar from '../../../../../assets/img/demo/bernard-nguyen-avatar.png';
import wadeRichardsAvatar from '../../../../../assets/img/demo/wadeRichardsAvatar.png';
import bruceRussellAvatar from '../../../../../assets/img/demo/bruce-russell-avatar.png';
import mitchellCooperAvatar from '../../../../../assets/img/demo/mitchell-cooper-avatar.png';


const duels = [
    {
        name: "Calvin Flores",
        avatar: calvinFloresAvatar,
        type: 'won',
        x: 175,
        y: 254,
    },
    {
        name: "Bernard Nguyen",
        avatar: bernardNguyenAvatar,
        type: 'neutral',
        x: 355,
        y: -255,
    },
    {
        name: "Wade Richards",
        avatar: wadeRichardsAvatar,
        type: 'won',
        x: 152,
        y: -15,
    },
    {
        name: "Wade Richards",
        avatar: wadeRichardsAvatar,
        type: 'lost',
        x: 32,
        y: 164,
    },
    {
        name: "Bruce Russell",
        avatar: bruceRussellAvatar,
        type: 'lost',
        x: 239,
        y: -95,
    }, {
        name: "Mitchell Cooper",
        avatar: mitchellCooperAvatar,
        type: 'lost',
        x: 239,
        y: -95,
    },
];

const types = [
    {
        text: 'Won',
        dataField: 'won',
        color: '#2B82F7'
    }, {
        text: 'Neutral',
        dataField: 'neutral',
        color: '#333333'
    }, {
        text: 'Lost',
        dataField: 'lost',
        color: '#F96274'
    },
];

class DuelsModal extends FullProfileModalBase {
    /**
     * Render the components within the body of the modal.
     * @returns {React.ReactNode} The body of the modal.
     */
    renderBody = () => {
        return (
            <Fragment>
                {this.renderGoalMaps()}
                {this.renderTable()}
            </Fragment>
        );
    };

    /**
     * Renders definitions of circles in goal maps.
     * @return {React.ReactNode} The arrows definitions.
     */
    renderArrowIndicator = () => {
        return (
            <div className="indicators">
                <DuelsModal.ArrowIndicator color={"#2B82F7"} text={"Won"}/>
                <DuelsModal.ArrowIndicator color={"#333333"} text={"Neutral"}/>
                <DuelsModal.ArrowIndicator color={"#F96274"} text={"Lost"}/>
            </div>
        );
    };


    /**
     * Renders the goals map.
     * @return {React.ReactNode} The goal maps component.
     */
    renderGoalMaps = () => {
        const data = this.goalMapData();

        return (
            <div className="goal-map-container">
                {this.renderArrowIndicator()}
                <GoalMap duels={data}>
                    {data.map(item => <GoalMap.Node nodeType='circle' x={item.x} y={item.y} color={item.color} radius={40}/>)}
                </GoalMap>
            </div>
        );
    };


    renderTable = () => {
        const rows = this.tableData();

        return (
            <DuelsDataTable rows={rows}/>
        )
    };

    goalMapData = () => {
        const data = this.duelsData();
        const types = this.duelsTypes();

        return data.map((item) => {
            return {
                x: item.x,
                y: item.y,
                color: types.filter((type) => type.dataField === item.type)[0].color,
            }
        });
    };

    tableData = () => {
        /// TODO: Optimize function.

        const data = this.duelsData();
        const types = this.duelsTypes();
        const uniqueItems = Array.from(new Set(data.map(item => (item.name))));
        return uniqueItems.map((name) => ({
            name: name,
            avatar: data.filter(player => player.name === name)[0].avatar,
            results: types.map((type) => ({
                text: type.text,
                color: type.color,
                count: data.filter(player => name === player.name && player.type === type.dataField).length,
            }))
        }));
    };

    duelsTypes = () => types;
    duelsData = () => duels;

    /**
     * Returns default size of modal.
     * @returns {string} The modal size.
     */
    defaultSize = () => "md";

    /**
     * Returns classname of modal.
     * @returns {string} The classname modal.
     */
    modalClassname = () => "duels-modal";

    static defaultProps = {
        headerTitle: "Duels",
        headerSubtitle: "9 of 10 | 90% Accuracy",
    };
}

DuelsModal.ArrowIndicator = ArrowIndicator;
export default DuelsModal;
